import {
  Button,
  Col,
  Modal,
  Row,
  Space,
  Typography,
} from "../../common/utils/antd-imports/AntdImports";
import React, { useState } from "react";
import { ReactComponent as Logo } from "../../../assests/amp_logo.svg";
import "../../../main.css";
import { ReactComponent as DownloadIcon } from "../../../assests/download-icon.svg";
import { ReactComponent as CancelIcon } from "../../../assests/cancel-icon.svg";

import "./ViewRFP.css";
import RequestExternalSearch from "./RequestExternalSearch";
import { useDispatch } from "react-redux";
import { downloadRFPSearchCriteria } from "../../../store/thunks/buyer-thunks/BuyerThunks";

const ViewRFP = ({
  viewRFPModal,
  setViewRFPModal,
  campaignInfo,
  loggedInUser,
}) => {
  const { Text } = Typography;
  const dispatch = useDispatch();
  const [requestExtersearch, setRequestExternalSearch] = useState(false);

  const dmaAreas =
    campaignInfo?.area_rfp_details?.map((area) => ({
      cityName: area?.city_name,
      stateName: area?.state_name,
    })) || [];

  const dmaDates =
    campaignInfo?.rfp_search_criteria_preview?.dma_dates?.map((dateStr) => {
      const [startDate, endDate] = dateStr.split("::");

      const start = new Date(startDate);
      const end = new Date(endDate);

      // Calculate difference in days (+1 to include both start and end date)
      const durationDays =
        Math.floor((end - start) / (1000 * 60 * 60 * 24)) + 1;

      return { startDate, endDate, durationDays };
    }) || [];

  const mergedDmaInfo = dmaAreas?.map((area, index) => ({
    ...area,
    ...dmaDates[index],
  }));

  const getDateOnly = (isoString) => {
    if (!isoString) return null;
    try {
      return new Date(isoString).toISOString().split("T")[0];
    } catch (e) {
      console.error("Invalid date:", isoString);
      return null;
    }
  };
  const productTypes = campaignInfo?.rfp_search_criteria_preview?.product_type;

  const display = Array.isArray(productTypes)
    ? productTypes?.join(", ")
    : productTypes || "No product types";

  const handleRequestSearch = () => {
    setRequestExternalSearch(true);
    setViewRFPModal(false);
  };

  const handleViewRFPDownload = () => {
    const payload = {
      campaignId: campaignInfo?.id,
    };
    dispatch(downloadRFPSearchCriteria(payload));
  };
  const safeJoin = (value) => {
    // Handling the something it is not array to use the join
    if (Array.isArray(value)) return value.join(", ");
    if (value === null || value === undefined) return "-";
    return String(value); // convert non-array to text safely
  };
  
  const getInstructions =(parameterType) =>{
        if(parameterType == "true") return "Yes"
        else return "No" 
  }
  return (
    <>
      <Modal
        open={viewRFPModal}
        closable={false}
        width={841}
        footer={false}
        className="view-rfp-modal"
        title={
          <Row>
            <Col span={22}>
              <Row className="view-rfp-title">
                <Col span={10}>
                  <Text className="request-proposal-txt">
                    Request for Proposal{" "}
                  </Text>
                </Col>
                <Col span={14} className="view-rfp-button-col">
                  <Button
                    className="external-searc-btn"
                    onClick={handleRequestSearch}
                  >
                    <Text className="external-searc-btn-txt">
                      Request External Search
                    </Text>
                  </Button>
                  <Button
                    className="view-download-btn"
                    onClick={handleViewRFPDownload}
                  >
                    <DownloadIcon color="#fff" />
                    <Text className="view-download-btn-txt">
                      Download RFP Pdf
                    </Text>
                  </Button>
                </Col>
              </Row>
            </Col>

            <Col span={1} offset={1} className="view-rfp-title">
              <div
                className="close-model-icon"
                onClick={() => setViewRFPModal(false)}
              >
                <div>
                  <CancelIcon />
                </div>
              </div>
            </Col>
          </Row>
        }
      >
        <div className="view-rfp-cont">
          <Space direction="vertical" size={25} style={{ width: "100%" }}>
            <div>
              <Row className="color-bar"></Row>
              <Row className="view-rfp-cont-row">
                <Col>
                  <Logo className="view-rfp-logo" />
                </Col>
              </Row>
            </div>

            <div>
              <Row>
                <Text className="external-search-request">
                  Request for External Search
                </Text>
              </Row>
              <Row>
                <Text className="request-details">AMP # : {campaignInfo?.cid}</Text>{"  "}
              </Row>
              <Row>
                <Text className="request-details">
                  Campaign : {campaignInfo?.name}
                </Text>
              </Row>
              <Row>
                <Text className="request-details">
                  User Name : {[campaignInfo?.first_name ,campaignInfo?.last_name] 
                              .filter(Boolean)
                              .join(" ") || "NA"}
                </Text>
              </Row>
              <Row>
                <Text className="request-details">
                  Email : {campaignInfo?.email || "NA"} 
                </Text>
              </Row>
              <Row>
                <Text className="request-details">
                  Ph No : {campaignInfo?.phone || "NA"}
                </Text>
              </Row>
              <Row>
                <Text className="request-details">
                  Brand Goal:{" "}
                  {campaignInfo?.rfp_search_criteria_preview?.brand_goal
                    ?.length > 0
                    ? safeJoin(
                        campaignInfo?.rfp_search_criteria_preview?.brand_goal
                      )
                    : ""}
                </Text>
              </Row>
              <Row>
                <Text className="request-details">
                  Business Commercial Goal:{" "}
                  {campaignInfo?.rfp_search_criteria_preview?.business_goal
                    ?.length > 0
                    ? safeJoin(
                        campaignInfo?.rfp_search_criteria_preview?.business_goal
                      )
                    : ""}
                </Text>
              </Row>
              <Row>
                <Text className="request-details">Formats: {display} </Text>
              </Row>
              <Row>
                <Text className="request-details">
                  Budget Range: ${campaignInfo?.rfp_search_criteria_preview?.est_budget_from} - ${campaignInfo?.rfp_search_criteria_preview?.est_budget_to}
                </Text>
              </Row>
               <Row>
                <Text className="request-details">
                  Age: {campaignInfo?.rfp_search_criteria_preview?.age}
                </Text>
              </Row>
              <Row>
                <Text className="request-details">
                  Marketing Funnels:{" "}
                  {campaignInfo?.rfp_search_criteria_preview?.marketing_funnel
                    ?.length > 0
                    ? safeJoin(
                        campaignInfo?.rfp_search_criteria_preview
                          ?.marketing_funnel
                      )
                    : ""}
                </Text>
              </Row>
              <Row>
                <Text className="request-details">
                  Income Range: ${campaignInfo?.rfp_search_criteria_preview?.income_from} - ${campaignInfo?.rfp_search_criteria_preview?.income_to}
                </Text>
              </Row>
              <Row>
                <Text className="request-details">
                  Ethnicity:{" "}
                  {campaignInfo?.rfp_search_criteria_preview?.ethnicity
                    ?.length > 0
                    ? safeJoin(
                        campaignInfo?.rfp_search_criteria_preview?.ethnicity
                      )
                    : ""}
                </Text>
              </Row>
              <Row>
                <Text className="request-details">
                  Restrictions:{" "}
                  {campaignInfo?.rfp_search_criteria_preview?.restrictions
                    ?.length > 0
                    ? safeJoin(
                        campaignInfo?.rfp_search_criteria_preview?.restrictions
                      )
                    : ""}
                </Text>
              </Row>
              <Row>
                <Text className="request-details">
                  Instructions:{" "}
                  <Row>
                  <Col span={12}> 
                  <div className="rfp-view-label">Do you have specific creative to run? :</div>
                  {getInstructions(campaignInfo?.rfp_search_criteria_preview?.creative_to_run)} </Col>
                  <Col span={12}><div className="rfp-view-label">Specific Messsage :</div> {getInstructions(campaignInfo?.rfp_search_criteria_preview?.specific_message)}</Col>
                  <Col span={12}><div className="rfp-view-label">Call to Action:</div>{getInstructions(campaignInfo?.rfp_search_criteria_preview?.call_to_action)}</Col>
                  <Col span={12}><div className="rfp-view-label">Product Animation:</div>{getInstructions(campaignInfo?.rfp_search_criteria_preview?.product_animation)}</Col>
                  </Row>
                </Text>
              </Row>
              <Row>
                <Text className="request-details">
                  Deadline: {getDateOnly(campaignInfo?.due_date)}
                </Text>
              </Row>
            </div>

            <div>
              <Row className="view-table-header">
                <Col sm={10} md={8} lg={5}>
                  <Text className="table-heading-txt">EST’D FLIGHT START</Text>
                </Col>
                <Col sm={10} md={8} lg={5}>
                  <Text className="table-heading-txt">FLIGHT END</Text>
                </Col>
                <Col sm={10} md={8} lg={5}>
                  <Text className="table-heading-txt">CITY</Text>
                </Col>
                <Col sm={10} md={8} lg={5}>
                  <Text className="table-heading-txt">STATE</Text>
                </Col>
                <Col sm={10} md={8} lg={4}>
                  <Text className="table-heading-txt">FLIGHT DAYS</Text>
                </Col>
              </Row>
              {mergedDmaInfo &&
                mergedDmaInfo?.map((data, index) => (
                  <Row className="view-table-container">
                    <>
                      <Col sm={10} md={8} lg={5}>
                        <Text className="table-content-txt">
                          {data?.startDate}
                        </Text>
                      </Col>
                      <Col sm={10} md={8} lg={5}>
                        <Text className="table-content-txt">
                          {data?.endDate}
                        </Text>
                      </Col>
                      <Col sm={10} md={8} lg={5}>
                        <Text className="table-content-txt">
                          {data?.cityName}
                        </Text>
                      </Col>
                      <Col sm={10} md={8} lg={5}>
                        <Text className="table-content-txt">
                          {data?.stateName}
                        </Text>
                      </Col>
                      <Col sm={10} md={8} lg={4}>
                        <Text className="table-content-txt">
                          {data?.durationDays}{" "}
                        </Text>
                      </Col>
                    </>
                  </Row>
                ))}
            </div>
            <div>
              <Row align="middle" justify="center">
                <Text className="support-txt-view">
                  Need assistance? Contact support at{" "}
                  <a
                    href="mailto:support@advertisingmarketplace.com"
                    style={{ color: "#d2042d" }}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    support@advertisingmarketplace.com.
                  </a>
                </Text>
              </Row>
            </div>
            <div>
              <Row className="view-rfp-footer">
                <Text className="view-greet-msg">
                  We make advertising easy<sup className="superscript">SM</sup>
                </Text>
              </Row>
            </div>
          </Space>
        </div>
      </Modal>

      <RequestExternalSearch
        requestExtersearch={requestExtersearch}
        setRequestExternalSearch={setRequestExternalSearch}
        campaignInfo={campaignInfo}
        loggedinUser={loggedInUser}
      />
    </>
  );
};

export default ViewRFP;
